// This is how a normal module looks like. You can copy paste this
// for any new module you want to create. Then you can import it in
// main.js and call "init()" to execute the code.


const GeminiSlider = ((($) => {
  let slider;
  let i;
  function init() {
    slider = $('.slider-gemini-img-slider');
    $('.slider-gemini-text-slider').slick({
      slidesToShow: 1,
      asNavFor: '.slider-gemini-img-slider',
      arrows: false,
      fade: true
    });
    slider.slick({
      asNavFor: '.slider-gemini-text-slider',
      centerMode: true,
      slidesToShow: 1,
      centerPadding: '180px',
      prevArrow: $('.gemini-left'),
      nextArrow: $('.gemini-right'),
      responsive: [
        {
          breakpoint: 1024,
          settings: {
            slidesToShow: 1,
            centerPadding: '100px',
          }
        },
        {
          breakpoint: 576,
          settings: {
            slidesToShow: 1,
            centerPadding: '50px',
          }
        }
      ],
    });
    slider.on('init reInit afterChange', function(event, slick, currentSlide, nextSlide) {
      $(this);
      nextSlide;
      i = (currentSlide ? currentSlide : 0) + 1;
      $('.gemini-slider-pages').html('<span class="current">0' + i + '</span><span class="summary">0' + slick.slideCount + '</span>');
    });
  }

  return {
    init,
  };
}))(jQuery);


// don't forget to export
export default GeminiSlider;



// WEBPACK FOOTER //
// ./src/static/js/modules/gemini-slider.js